import { useLayoutEffect } from 'react';

// Pages are pre-rendered at build time (scripts/prerender) into a
// <div id="kk-prerender"> that sits beside #root, with CSS hiding #root
// while it exists. The app mounts into #root as usual; this component is
// rendered inside the route's <Suspense>, so it commits only once Clerk has
// loaded and the page's lazy chunk has arrived – the moment the live page
// can replace the static one without a "Connecting..." flash in between.
export const PRERENDER_ID = 'kk-prerender';

// Read once, when the bundle first runs (CRA's scripts are deferred, so the
// document has been parsed by then).
export const wasPrerendered =
  typeof document !== 'undefined' && !!document.getElementById(PRERENDER_ID);

export default function PrerenderHandoff() {
  useLayoutEffect(() => {
    const el = document.getElementById(PRERENDER_ID);
    if (el) el.remove();
  }, []);
  return null;
}
